// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3yCRy","list":"BalanceDue_list__PYOJ4","listRow":"BalanceDue_listRow__32fKL","total":"BalanceDue_total__2sNxN"};